/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEftFileNum.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/eft-file-num";

export class AutogenModelEftFileNum<RowType extends ModelRow> extends Endpoint<RowType, RowEftFileNumFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEftFileNum extends ModelRow<RowEftFileNumFields> {
	constructor(values?: Partial<RowEftFileNumFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEftFileNumFields {
	company_id: string;
	currency_type: string;
	eft_file_number: number;
	originator_id: string;
}

